// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarAdmin_navbar__WhLJb","logo":"NavbarAdmin_logo__Dv9ti","navLinks":"NavbarAdmin_navLinks__Bn--R","navItem":"NavbarAdmin_navItem__w+3dM"};